'use client';

import { Logger } from './logging-types';
import { sLog } from './log';
import { EcEnv } from '@castlery/config';
import { createLogLevelFilter } from './log-level-utils';

let logger: Logger;

export function cLog() {
  if (!logger && isClient()) {
    logger = initLogger();
  }
  return logger ?? (isClient() ? console : sLog());
}

function initLogger() {
  // 🔑 创建日志级别过滤器（初始化时计算一次，性能优化）
  const configuredLevel = EcEnv.NEXT_PUBLIC_LOG_LEVEL ?? 'info';
  const shouldLog = createLogLevelFilter(configuredLevel);

  // 在客户端使用增强的 console 日志，添加上下文信息
  const clientLogger: Logger = {
    debug(msg, obj) {
      if (shouldLog('debug')) {
        console.debug(`[${getTimestamp()}] [DEBUG] ${msg}`, addClientContext(obj));
      }
    },
    info(msg, obj) {
      if (shouldLog('info')) {
        console.info(`[${getTimestamp()}] [INFO] ${msg}`, addClientContext(obj));
      }
    },
    warn(msg, obj) {
      if (shouldLog('warn')) {
        console.warn(`[${getTimestamp()}] [WARN] ${msg}`, addClientContext(obj));
      }
    },
    error(msg, obj) {
      if (shouldLog('error')) {
        console.error(`[${getTimestamp()}] [ERROR] ${msg}`, addClientContext(obj));
      }
    },
  };

  return clientLogger;
}

function addClientContext(obj?: object) {
  return {
    service: getServiceName(),
    env: EcEnv.NEXT_PUBLIC_APPLICATION_ENV,
    country: EcEnv.NEXT_PUBLIC_COUNTRY,
    channel: EcEnv.NEXT_PUBLIC_CHANNEL,
    version: EcEnv.NEXT_PUBLIC_VERSION,
    timestamp: getTimestamp(),
    ...obj,
  };
}

function getTimestamp(): string {
  return new Date().toISOString();
}

function getServiceName() {
  const channel = EcEnv.NEXT_PUBLIC_CHANNEL?.toLowerCase();
  return `joyboy-${channel}`;
}

function isClient() {
  return typeof window !== 'undefined';
}
